import axios from "axios";
import config from "./config";
export default {
    async getFromDB(filename) {
        try {
            let reply = await axios.get(config.app_url == undefined ? "" : config.app_url + "files/" + filename, {
                responseType: "arraybuffer",
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                },
            });
            return reply.data;
        }
        catch (error) {
            return null;
        }
    },
    async getFromFileSystem(filename) {
        try {
            let reply = await axios.get(config.app_url == undefined ? "" : config.app_url + "files/file-system", {
                responseType: "arraybuffer",
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                    "ok-filename": filename,
                },
            });
            return reply.data;
        }
        catch (error) {
            return null;
        }
    },
    async uploadToFileSystem(file, filename) {
        try {
            let reply = await axios.post(config.app_url == undefined ? "" : config.app_url + "files/file-system", file, {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                    "Content-Type": "application/octet-stream",
                    "ok-filename": filename,
                },
            });
            return reply.data;
        }
        catch (error) {
            console.log("Error uploadToFileSystem", error);
            return null;
        }
    },
    async uploadToDatabase(file) {
        try {
            // Create form data and append file
            let formData = new FormData();
            formData.append("file", file);
            // Make post request
            let reply = await axios.post(config.app_url == undefined ? "" : config.app_url + "uploads", formData, {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                    "Content-Type": "multipart/form-data",
                },
            });
            return reply.data;
        }
        catch (error) {
            return null;
        }
    },
    async uploadToS3(filename, file, pub) {
        try {
            // Make post request
            var xhr = new XMLHttpRequest();
            xhr.open("POST", config.app_url == undefined ? "" : config.app_url + "files/s3", false);
            xhr.setRequestHeader("Authorization", "Bearer " + window.localStorage.getItem("openkit"));
            xhr.setRequestHeader("Content-Type", "application/octet-stream");
            xhr.setRequestHeader("ok-filename", filename);
            if (pub) {
                xhr.setRequestHeader("ok-public", "true");
            }
            else {
                xhr.setRequestHeader("ok-public", "false");
            }
            xhr.send(file);
            return true;
        }
        catch (error) {
            return null;
        }
    },
    async uploadToWordpress(filename, file) {
        try {
            let reply = await axios.post(config.app_url == undefined ? "" : config.app_url + "files/wp", file, {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                    "Content-Type": "application/octet-stream",
                    "ok-filename": filename,
                },
            });
            return reply.data;
            // // Make post request
            // var xhr = new XMLHttpRequest();
            // xhr.open(
            //   "POST",
            //   config.app_url == undefined ? "" : config.app_url + "files/wp",
            //   false
            // );
            // xhr.setRequestHeader(
            //   "Authorization",
            //   "Bearer " + window.localStorage.getItem("openkit")
            // );
            // xhr.setRequestHeader("Content-Type", "application/octet-stream");
            // xhr.setRequestHeader("ok-filename", filename);
            // xhr.onreadystatechange = function () {
            //   console.log("xhr.response", xhr.response);
            //   if (xhr.readyState === 4) {
            //     return xhr.response;
            //   }
            // };
            // xhr.send(file);
        }
        catch (error) {
            return null;
        }
    },
    async updateToWordpress(id, filename, file) {
        try {
            // Make post request
            var xhr = new XMLHttpRequest();
            xhr.open("POST", config.app_url == undefined ? "" : config.app_url + "files/wp/" + id, false);
            xhr.setRequestHeader("Authorization", "Bearer " + window.localStorage.getItem("openkit"));
            xhr.setRequestHeader("Content-Type", "application/octet-stream");
            xhr.setRequestHeader("ok-filename", filename);
            xhr.send(file);
            return true;
        }
        catch (error) {
            return null;
        }
    },
    async removeFromWordpress(id) {
        try {
            // Make post request
            let reply = await axios.delete(config.app_url == undefined ? "" : config.app_url + "files/wp/" + id, {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                },
            });
            return reply;
        }
        catch (error) {
            return null;
        }
    },
    async removeFromS3(filePath) {
        try {
            // Make post request
            let reply = await axios.delete(config.app_url == undefined ? "" : config.app_url + "files/s3", {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                    "ok-filename": filePath,
                },
            });
            return reply;
        }
        catch (error) {
            return null;
        }
    },
    async getFromS3(filePath) {
        try {
            // Make post request
            let reply = await axios.get(config.app_url == undefined ? "" : config.app_url + "files/s3", {
                headers: {
                    Authorization: "Bearer " + window.localStorage.getItem("openkit"),
                    "ok-filename": filePath,
                },
            });
            return reply.data;
        }
        catch (error) {
            return null;
        }
    },
};
